import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useTerminalStore = create()(
    persist(
        (set) => ({
            refetchTerminalEventLogs: false,
            storeRefetchTerminalEventLogs: (refetchTerminalEventLogs) => set(() => ({ refetchTerminalEventLogs: refetchTerminalEventLogs })),
            queryEventLogs: getInitialQuery(),
            storeQueryEventLogs: (query) => set(() => ({ queryEventLogs: query })),

            refetchTerminalTransactions: false,
            storeRefetchTerminalTransactions: (refetchTerminalTransactions) => set(() => ({ refetchTerminalTransactions: refetchTerminalTransactions })),
            queryTransactions: getInitialQuery(),
            storeQueryTransactions: (query) => set(() => ({ queryTransactions: query }))
        }),
        {
            name: 'terminal-storage'
        }
    )
);


export default useTerminalStore;